export default macAddress => RegExp(/^([0-9a-f][0-9a-f]){6}$/i)
  // eslint-disable-next-line no-useless-escape
  .test(macAddress.trim().replace(/[:\-]/g, ""));
